import { Injectable } from '@angular/core';
import { Device, DeviceInfo } from '@capacitor/device';
import { BehaviorSubject } from 'rxjs';

@Injectable({
   providedIn: 'root'
})
export class DeviceService {

   public device = new BehaviorSubject<{ type: 'desktop' | 'mobile'; width: number; }>({ type: 'mobile', width: 700 });
   public deviceWidth = new BehaviorSubject<number>(700);
   public nativeDevice = new BehaviorSubject<DeviceInfo>(undefined);

   constructor() { }

   detectDevice() {
      const dev: any = {};
      const ua = navigator.userAgent;

      dev.type = /android|iPad|iPhone|iPod/i.test(ua) ? 'mobile' : 'desktop';
      dev.width = window.innerWidth;
      this.device.next(dev);
   }

   changeDeviceWith() {
      this.deviceWidth.next(innerWidth);
   }

   getNativeDevice() {
      Device.getInfo().then(info => {
         this.nativeDevice.next(info);
      }).catch(err => {
         // console.log(err);
      });

   }
}
